module.exports = __webpack_public_path__ + "img/Messfahrzeug.b8b7ba68.svg";